import { render, staticRenderFns } from "./ReviewRequestModal.vue?vue&type=template&id=71d0dc62&scoped=true"
import script from "./ReviewRequestModal.vue?vue&type=script&lang=js"
export * from "./ReviewRequestModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewRequestModal.vue?vue&type=style&index=0&id=71d0dc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0dc62",
  null
  
)

export default component.exports